import { FC, useMemo } from 'react'
import { useIntl } from 'react-intl'

import { Option } from '@models/option'
import { QueueNumberTypeEnum } from '@models/queueNumber'

import { SelectField, SelectFieldProps } from '@components/Form/Select'

type QueueNumberTypeSelectFieldProps = Omit<SelectFieldProps, 'options'>

const QueueNumberTypeSelectField: FC<QueueNumberTypeSelectFieldProps> = (props) => {
  const intl = useIntl()

  const options: Array<Option> = useMemo(
    () => [
      new Option({
        label: intl.formatMessage({
          id: `enum.queue_number_type.${QueueNumberTypeEnum.Normal.toLowerCase()}`,
        }),
        value: QueueNumberTypeEnum.Normal,
      }),
      new Option({
        label: intl.formatMessage({
          id: `enum.queue_number_type.${QueueNumberTypeEnum.Appointment.toLowerCase()}`,
        }),
        value: QueueNumberTypeEnum.Appointment,
      }),
    ],
    // eslint-disable-next-line
    []
  )

  return (
    <SelectField
      {...props}
      options={options}
      noOptionsMessage={() => {
        return intl.formatMessage({ id: 'select.no_option' })
      }}
    />
  )
}

export default QueueNumberTypeSelectField
